import { Handle, Position } from '@xyflow/react'

import xmproLogo from '@/assets/XMPROLogo.png'
import vertexLogo from '@/assets/gcp/Vertex-AI.png'
import awsDeepLearningLogo from '@/assets/aws/Arch_AWS-Deep-Learning-AMIs_64@5x.png'
import azureMachineLearningLogo from '@/assets/msft/azure-machine-learning.svg'

function MachineLearningNode() {
  const mlLogo = () => {
    const demoEnv = localStorage.getItem('TARGET')
    if (demoEnv === 'MSFT') {
      return azureMachineLearningLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else if (demoEnv === 'AWS') {
      return awsDeepLearningLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else if (demoEnv === 'GCP') {
      return vertexLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else {
      return xmproLogo
    }
  }
  return (
    <div className="custom-node-robots robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div className="text-center">
            <img src={mlLogo()} alt="ML Logo" className="custom-node-plc-logo" />
          </div>
          <div className="text-center">
            <b>AI</b>
          </div>
        </div>
      </div>

      <Handle type="target" position={Position.Bottom} />
      <Handle type="source" position={Position.Left} />
    </div>
  )
}

export default MachineLearningNode
